import React, { useState, useEffect } from 'react';
import { Box, Typography, Card, CardContent, Grid, CircularProgress, Alert } from '@mui/material';
import SchoolIcon from '@mui/icons-material/School';
import PersonIcon from '@mui/icons-material/Person';
import PeopleIcon from '@mui/icons-material/People';
import axios from '../../utils/axios'; // Use the same axios import as UniversityManagement

const AdminHome = ({ adminInfo }) => {
  const [dashboardData, setDashboardData] = useState({
    universities: 0,
    faculty: 0,
    students: 0
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        setLoading(true);
        // Use the same axios instance that works in UniversityManagement
        const response = await axios.get('/api/admin/stats/');
        console.log('Stats API response:', response.data);
        
        setDashboardData({
          universities: response.data.universities || 0,
          faculty: response.data.faculty || 0,
          students: response.data.students || 0
        });
        setError(null);
      } catch (err) {
        console.error('Error fetching admin stats:', err);
        setError(`Failed to load dashboard data: ${err.message}`);
      } finally {
        setLoading(false);
      }
    };

    fetchStats();
  }, []);

  // Card style config
  const cardStyle = {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    borderRadius: 2,
    boxShadow: 3,
    transition: 'transform 0.2s ease-in-out',
    '&:hover': {
      transform: 'scale(1.03)',
    },
  };

  const iconStyle = {
    fontSize: 40,
    mb: 2,
  };

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={{ padding: 4 }}>
      <Typography variant="h4" sx={{ fontWeight: 'bold', color: '#2C2C2C', mb: 4 }}>
        Admin Dashboard
      </Typography>
      
      {error && (
        <Alert severity="error" sx={{ mb: 3 }}>
          {error}
        </Alert>
      )}
      
      <Grid container spacing={4}>
        {/* Universities Card */}
        <Grid item xs={12} md={4}>
          <Card sx={{ ...cardStyle, bgcolor: '#e3f2fd' }}>
            <CardContent sx={{ textAlign: 'center', py: 4 }}>
              <SchoolIcon sx={{ ...iconStyle, color: '#1976d2' }} />
              <Typography variant="h3" sx={{ fontWeight: 'bold', mb: 1 }}>
                {dashboardData.universities}
              </Typography>
              <Typography variant="h6" color="text.secondary">
                Universities
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        {/* Faculty Card */}
        <Grid item xs={12} md={4}>
          <Card sx={{ ...cardStyle, bgcolor: '#e8f5e9' }}>
            <CardContent sx={{ textAlign: 'center', py: 4 }}>
              <PersonIcon sx={{ ...iconStyle, color: '#388e3c' }} />
              <Typography variant="h3" sx={{ fontWeight: 'bold', mb: 1 }}>
                {dashboardData.faculty}
              </Typography>
              <Typography variant="h6" color="text.secondary">
                Faculty Members
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        {/* Students Card */}
        <Grid item xs={12} md={4}>
          <Card sx={{ ...cardStyle, bgcolor: '#fff3e0' }}>
            <CardContent sx={{ textAlign: 'center', py: 4 }}>
              <PeopleIcon sx={{ ...iconStyle, color: '#f57c00' }} />
              <Typography variant="h3" sx={{ fontWeight: 'bold', mb: 1 }}>
                {dashboardData.students}
              </Typography>
              <Typography variant="h6" color="text.secondary">
                Students
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
};

export default AdminHome;